import { render } from "./JobsList.vue?vue&type=template&id=397446d9"
import script from "./JobsList.vue?vue&type=script&lang=js"
export * from "./JobsList.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__